import { render, staticRenderFns } from "./shebeigl.vue?vue&type=template&id=3905bc98&scoped=true&"
import script from "./shebeigl.vue?vue&type=script&lang=js&"
export * from "./shebeigl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3905bc98",
  null
  
)

export default component.exports